// extracted by mini-css-extract-plugin
module.exports = {"legal-cases-wrapper":"_3cY4D","legal-cases-name":"_1OTch","legal-cases-description":"_3U6FP","legal-cases-text":"_1DHv8"};